import { useEffect, useRef, useState } from "react";
import "../../styles/OtpInput/OtpInput.css"

interface OtpInputProps {
  value: string;
  onChange: (otp: string) => void;
  length?: number;
}

const OtpInput: React.FC<OtpInputProps> = ({
  value,
  onChange,
  length = 6,
}) => {
  const [digits, setDigits] = useState<string[]>(Array(length).fill(""));
  const inputsRef = useRef<Array<HTMLInputElement | null>>([]);

  useEffect(() => {
    const valueArray = value.split("").slice(0, length);
    setDigits((prev) =>
      prev.map((_, i) => valueArray[i] || "")
    );
  }, [value, length]);

  const handleChange = (val: string, index: number) => {
    if (!/^[0-9]?$/.test(val)) return;

    const newDigits = [...digits];
    newDigits[index] = val;
    setDigits(newDigits);
    onChange(newDigits.join(""));

    if (val && index < length - 1) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
    if (e.key === "Backspace" && !digits[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, length);

    if (!pasteData) return;

    const newDigits = pasteData.split("");
    const updated = [...Array(length)].map((_, i) => newDigits[i] || "");

    setDigits(updated);
    onChange(updated.join(""));

    const focusIndex = Math.min(pasteData.length, length) - 1;
    inputsRef.current[focusIndex]?.focus();
  };

  return (
    <div className="otp-container">
      {digits.map((digit, index) => (
        <input
          key={index}
          ref={(el) => (inputsRef.current[index] = el)}
          className="otp-input"
          type="text"
          inputMode="numeric"
          maxLength={1}
          value={digit}
          onChange={(e) => handleChange(e.target.value, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          autoComplete="one-time-code"
          onPaste={handlePaste}
        />
      ))}
    </div>
  );
};

export default OtpInput;
